import styled from 'styled-components';

export const SatoshiResultContainer = styled.div<{
  visible: boolean;
}>`
  position: absolute;
  height: 100%;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
  top: 0;
`;
